import { useId } from "react";
import "./style.css";

export const addressFields = [
  ["street", "Calle y número", "street-address"],
  ["zipCode", "Código postal", "postal-code"],
  ["city", "Ciudad", "address-level2"],
  ["state", "Provincia", "address-level1"],
  ["country", "País", "country-name"],
  ["phone", "Teléfono", "tel"],
  ["name", "Nombre de la dirección", "off"],
];

export const newAddress = () => ({ ...Object.fromEntries(addressFields.map(([key]) => [key, ""])), country: "España", number: "", floor: "", door: "", block: "" });

// Read the actual form values as well: browsers may autofill without firing React onChange.
export const addressFromForm = (form, address) => ({ number: "", floor: "", door: "", block: "", ...address, ...Object.fromEntries(addressFields.map(([key]) => [key, String(new FormData(form).get(key) ?? address[key] ?? "").trim()])) });

export const AddressFields = ({ value, onChange, disabled = false, kind = "shipping" }) => {
  const id = useId();
  return <div className="shop-address-fields">
    <p className="shop-address-help">Introduce la calle primero. Puedes usar una dirección guardada en tu navegador y revisar los datos antes de guardar.</p>
    {addressFields.map(([key, label, autocomplete]) => <label className={`shop-address-field shop-address-${key}`} key={key} htmlFor={`${id}-${key}`}>
      <span>{label}{key === "name" && <small>Por ejemplo, Casa o Trabajo</small>}</span>
      <input id={`${id}-${key}`} name={key} type={key === "phone" ? "tel" : "text"} autoComplete={autocomplete === "off" ? "off" : `section-address ${kind} ${autocomplete}`} required={["name", "street", "city", "zipCode"].includes(key)} value={value[key] || ""} disabled={disabled} onChange={event => onChange(previous => ({ ...previous, [key]: event.target.value }))} />
    </label>)}
  </div>;
};
